import { asDecimal } from '@/lib/helpers/numeric'

/**
 * Conversion factors to m/min (base unit)
 */
const TO_M_MIN = {
    'km/h': 16.6667,
    'm/min': 1,
    'mph': 26.8224,
}

/**
 * Convert to m/min
 */
const toMMin = (value, unit) => value * (TO_M_MIN[unit] || 1)

/**
 * Convert from m/min
 */
const fromMMin = (mmin, unit) => mmin / (TO_M_MIN[unit] || 1)

/**
 * Convert speed between km/h, m/min, and mph
 *
 * @param {number} value - Value to convert
 * @param {string} unitIn - Source unit ('km/h', 'm/min', or 'mph')
 * @param {string} unitOut - Target unit ('km/h', 'm/min', or 'mph')
 * @param {number|null} decimals - Number of decimals (null to disable)
 * @param {boolean} returnString - If true, return formatted string
 * @returns {object|string}
 */
export const convertSpeed = (value, unitIn = 'km/h', unitOut = 'm/min', decimals = 0, returnString = false) => {
    unitOut = unitOut ?? 'm/min'

    // Convert to base unit (m/min) then to target
    const mmin = toMMin(value, unitIn)
    const speed = {
        value: fromMMin(mmin, unitOut),
        unit: unitOut,
    }

    if (decimals !== null) {
        speed.value = asDecimal(speed.value, decimals)
    }

    return returnString ? `${speed.value} ${speed.unit}` : speed
}
